import './index.scss'
import React from 'react'
import { connect } from 'react-redux'
import { userSettingsAddLayer, userSettingsRemoveLayer, userSettingsSet, userSettingsUpdateRequest } from '../../../../../action/user-settings-actions'
import ProBlocker from '../../../common/pro-blocker'
import LayerNodeDescription from './tooltip'
import LayerInfo, { localLegend } from './info'
import { multiTileHuntLayers } from '../../../../hunt-planner/huntplanner-layer-render/renderlayerFunction'
// Aliased for the same reason as the other entries here: see scripts/check-dispatch-recursion.js.
import { layerMenuTap as layerMenuTapAction } from '../../../../../action/layer-menu-actions'
import { isLayerBlocked, isLayerHiddenBySubscription } from '../../../../../lib/layer-access'
import { isTimeLayer } from '../../../../../lib/timeLayers/timeline'

class Layer extends React.Component {
  constructor(props) {
    super(props)
    this.shouldBlock = this.shouldBlock.bind(this)
  }

  shouldBlock() {
    const { userSubscriptions, layer } = this.props
    return isLayerBlocked(layer, userSubscriptions)
  }

  shouldHide() {
    const { userSubscriptions, layer } = this.props
    return isLayerHiddenBySubscription(layer, userSubscriptions)
  }

  checkForHuntPlanner() {
    let { selectedTab, huntplannerActiveLayerPayload } = this.props
    if (selectedTab == "huntplanner") {
      setTimeout(() => {
        // console.log('this is not wanted i guess pavan layer')
        // multiTileHuntLayers(
        //   huntplannerActiveLayerPayload.mapObj,
        //   huntplannerActiveLayerPayload.mapObjVal,
        //   huntplannerActiveLayerPayload.filter,
        //   huntplannerActiveLayerPayload.tile,
        //   huntplannerActiveLayerPayload.layerApi,
        //   huntplannerActiveLayerPayload.params,
        //   huntplannerActiveLayerPayload.layerData,
        //   huntplannerActiveLayerPayload.callback,
        // )
      }, 1000)
    }
  }

  render() {
    const { active, layer, settingId, favoriteLayers, userSettingsAddLayer, userSettingsRemoveLayer,
      favoriteLayersSelect, layerMenuTap } = this.props,
      isFavorite = favoriteLayers && favoriteLayers.indexOf(layer.id) !== -1,
      blockLayer = this.shouldBlock()

    if (layer.hideInLayerMenu || !layer.enabled || this.shouldHide()) {
      return null
    }
    return (
      <>
        {(this.props.productionLayers && layer.production) || !this.props.productionLayers ? <div className={`layer-container ${active ? 'layer-container-active' : ''}`}
          onClick={(e) => {
            e.stopPropagation()
            this.checkForHuntPlanner()
            layerMenuTap(layer, { settingId, active, fromFavorites: favoriteLayersSelect == 'favoriteLayers' })
          }}
        >
          {
            layer.layerNodeId !== 5 ? (
              <div onClick={(e) => {
                e.stopPropagation()
                if (isFavorite) {
                  userSettingsRemoveLayer(2, layer.id)
                }
                else {
                  userSettingsAddLayer(2, layer.id)
                }
              }}
                className={isFavorite ? 'layer-favorite-btn-active' : 'layer-favorite-btn'}>
              </div>
            ) : null
          }
          <div className='layer-node-container'>
            <img src={layer.largeImageUrl ? layer.largeImageUrl :
              layer.imageUrl ? layer.imageUrl : ''}
              // style={{ width: 100, height: 100 }}
              className='layer-node-image'
            ></img>
            <div className='layer-node-text-container'>
              <div className='layer-node-header-container' style={{ top: layer.layerNodeId === 5 ? '100%' : '' }}>
                <span className='layer-label'>{layer.name}</span>
              </div>
              {/* <div className='layer-node-description' style={{}}>
                <span title={layer.description} className='layer-label'> {layer.description}</span>
              </div> */}
              <LayerNodeDescription layer={layer} parent={false}></LayerNodeDescription>
            </div>

          </div>

          {
            blockLayer ? <ProBlocker /> : null
          }
          {/* Vendor layers have no Layer/Legend; of the time layers, only weather has one (its own). */}
          {(isTimeLayer(layer) ? !!localLegend(layer) : !layer.vendorId) && <LayerInfo layer={layer} />}
        </div> : ''}
      </>
    )
  }
}

const mapStateToProps = state => ({
  vendors: state.vendors,
  mapReference: typeof state.mapReference === 'function' ? state.mapReference() : null,
  userSubscriptions: state.user.userSubscription ? state.user.userSubscription : [],
  userSettings: state.userSettings,
  activeLayers: state.userSettings.find(setting => setting.settingId === 1) ?
    state.userSettings.find(setting => setting.settingId === 1).valueArray : [],
  favoriteLayers: state.userSettings.find(setting => setting.settingId === 2) ?
    state.userSettings.find(setting => setting.settingId === 2).valueArray : [],
  layersDictionary: state.layersDictionary,
  productionLayers: state.productionLayers,
  selectedTab: state.selectedTab,
  huntplannerActiveLayerPayload: state.huntplannerActiveLayerPayload
})

const mapDispatchToProps = dispatch => ({
  userSettingsAddLayer: (setting, id) => dispatch(userSettingsAddLayer(setting, id)),
  userSettingsUpdateRequest: (setting, id) => dispatch(userSettingsUpdateRequest(setting, id, false)),
  userSettingsRemoveLayer: (setting, id) => dispatch(userSettingsRemoveLayer(setting, id)),
  userSettingsSet: settings => dispatch(userSettingsSet(settings)),
  layerMenuTap: (layer, options) => dispatch(layerMenuTapAction(layer, options))
})

export default connect(mapStateToProps, mapDispatchToProps)(Layer)
